<div class="developer-settings-container">
  <div class="header">
    <h3>My OAuth2 Apps</h3>
    <button class="ui tiny primary button" (click)="newClient()">New OAuth2 App</button>
  </div>
  @if (oAuth2ClientList) {
    <div class="oauth2-app-list">
      @for (client of oAuth2ClientList; track client) {
        <div class="app-card ui segment">
          <div class="card-header">
            <div class="client-logo">
              <img class="client-logo-img" [src]="client.logo_uri || '/assets/application.svg'" alt="client logo">
            </div>
            <h4 class="app-name">{{client.client_name}}</h4>
            <div class="ui label">
              Id
              <div class="detail">{{client.client_id}}</div>
            </div>
          </div>
          <div class="card-content">
            <div class="left-area">
              <div class="ui label created-info">Created:<div class="detail">{{client.created_at}}</div></div>
            </div>
            <div class="button-area">
              <button class="ui tiny button" (click)="editServiceClient(client.client_id)">Webhook</button>
              <button class="ui tiny button edit-button" (click)="editClient(client.client_id)">Edit</button>
            </div>
          </div>
        </div>
      }
    </div>
  }
  @if (!oAuth2ClientList) {
    <div class="no-app-list">You have no OAuth2 Apps</div>
  }
</div>
